import styled from "styled-components";
import BackgroundImage from "./assets/background.jpg"

const Background = styled.div`
	position: absolute;
	inset: -10px; /* bleed past the viewport so the blur has no bright edge fringe */

	background-image: url(${BackgroundImage});
	background-position: center; /* Center the image */
	background-repeat: no-repeat; /* Do not repeat the image */
	background-size: cover; /* Resize the background image to cover the entire container */

	filter: blur(4px);
  	-webkit-filter: blur(4px);

	&::after {
		content: "";
		position: absolute;
		inset: 0;
		background: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.4));
	}
`;

const Container = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
	z-index: 1;

	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: clamp(20px, 4vh, 40px);

	padding: 24px;
	text-align: center;
`;

const TitleGroup = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
`;

const CoffeeShopText = styled.div`
	color: white;
	text-shadow: 0 2px 24px rgba(0, 0, 0, 0.55);
	font-family: EBGaramond-Bold;
	font-size: clamp(36px, 8vw, 56px);
	line-height: 1;
`; // EB Garamond Bold (81pt)

const SoundsText = styled.div`
	color: white;
	text-shadow: 0 2px 24px rgba(0, 0, 0, 0.55);
	font-family: Pacifico-Regular;
	font-weight: bold;
	font-size: clamp(54px, 12vw, 84px);
	line-height: 1.2;
	margin-top: 0;
`; // Pacifico Bold (134 pt)

const PlayerMobile = styled.iframe`
	border-radius: 12px;
	border: none;
	width: 90%;
	max-width: 420px;

	// Large devices (desktops, 992px and up)
	@media (min-width: 992px) {
		display: none;
	}
`;

const PlayerDesktop = styled.iframe`
	border-radius: 12px;
	border: none;
	width: min(600px, 60%);

	display: none;

	// Large devices (desktops, 992px and up)
	@media (min-width: 992px) {
		display: flex;
	}
`;

const LinksContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: clamp(20px, 5vw, 36px);
`;

const PlatformLogoContainer = styled.a`
	display: block;
	border-radius: 11px; /* shapes the focus outline; the logos carry their own rounded shapes */
	width: 44px;
	height: 44px;

	transition: transform 0.18s ease, filter 0.18s ease;

	&:hover {
		transform: translateY(-4px) scale(1.08);
		filter: drop-shadow(0 8px 12px rgba(0, 0, 0, 0.45));
	}

	&:active {
		transform: translateY(-1px) scale(1.02);
	}

	&:focus-visible {
		outline: 2px solid white;
		outline-offset: 3px;
	}

	// Large devices (desktops, 992px and up)
	@media (min-width: 992px) {
		width: 56px;
		height: 56px;
		border-radius: 14px;
	}

	@media (prefers-reduced-motion: reduce) {
		transition: none;

		&:hover,
		&:active {
			transform: none;
		}
	}
`;

const PlatformLogo = styled.img`
	display: block;
	width: 100%;
	height: 100%;
	object-fit: contain;
`;


export {
	Background,
	Container,
	TitleGroup,
	CoffeeShopText,
	SoundsText,
	PlayerMobile,
	PlayerDesktop,
	PlatformLogoContainer,
	PlatformLogo,
	LinksContainer
};
